﻿import $ from "jquery";
import defaultExport from "globalize/lib/globalize.js";

// it seems there is a difference between rolldown and rollup export handling, so we need to check for both cases
const g = defaultExport.Globalize || defaultExport;

$.format = function (a, b, c) { return g.format(a, b, c); };
$.parseDate = function(a, b, c) { return g.parseDate(a, b, c); };

function fixWinMobileBug() {
	// fix positioning of the datepicker as it does not display properly
	// when page is zoomed on WinMobile devices
	$(document).on("focus", ".hasDatepicker", function() {
		var $target = $(this);
		$target.datepicker("widget").addClass("td-embedded").position({
			my: "left top",
			at: "left bottom",
			of: $target
		});
	});
}

// return locale-aware options for datepicker
function getCalendarOptions() {
	for (var c in g.cultures) { /* simply fast-forward to the last */ }

	g.culture(c);

	var ci = g.culture().calendar;
	return {
		monthNames: ci.months.names,
		monthNamesShort: ci.months.namesAbbr,
		dayNames: ci.days.names,
		dayNamesShort: ci.days.namesAbbr,
		dayNamesMin: ci.days.namesShort,
		dateFormat: ci.patterns.d.replace(/[dMy]{1,4}/g,
			function($1) {
				return {
					dddd: "DD", ddd: "D", dd: "dd", d: "d",
					MMMM: "MM", MMM: "M", MM: "mm", M: "m",
					yyyy: "yy", yyy: "yy", yy: "y", y: "y"
				}[$1] || $1;
			}),
		firstDay: ci.firstDay,
		showMonthAfterYear: ci.patterns.Y.indexOf('M') > ci.patterns.Y.indexOf('y')
	};
}

// return all options for datepicker
function getDatePickerOptions(opts) {
	return $.extend(getCalendarOptions(), {
		showAnim: "",
		showOn: "button",
		constrainInput: false,
		buttonText: "Calendar",
		showOtherMonths: true,
		selectOtherMonths: true,
		prevText: "\u2039",
		nextText: "\u203A",
		classes: { "ui-datepicker": "td-embedded" }
	}, opts);
}

var originalDatePicker;

function newDatePicker(options) {
	/* jshint validthis: true */
	var args = arguments;
	return typeof options == "string"
		? originalDatePicker.apply(this, args)
		: this.each(function() {
			/* jshint validthis: true */
			var me = $(this);
			if(!me.hasClass("hasDatepicker")) {
				var allOptions = getDatePickerOptions(args[0]);
				me.addClass("ui-split").wrap("<nobr>");
				originalDatePicker.apply(me, [ allOptions ]);
				var button = me.next();
				$("<span>", { "class": "ui-icontext" }).text(button.text()).appendTo(button.empty().addClass("ui-button ui-split ui-icon-only ui-icon-calendar"));
			} else {
				originalDatePicker.apply(me, args);
			}
		});
}

function overrideDatePicker() {
	fixWinMobileBug();
	if(originalDatePicker == null) {
		originalDatePicker = $.fn.datepicker;
		$.fn.datepicker = newDatePicker;
		return originalDatePicker;
	}
}

export { getCalendarOptions, getDatePickerOptions, overrideDatePicker, g as Globalize };